import React from 'react';
import primaryLogo from '../../resources/full-logo.svg';
import secondaryLogo from '../../resources/secondary-logo.svg';
import { Div } from 'Common/components/Atoms/Div';
import { Flex } from 'Common/components/Atoms/Flex';
import { NavLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

interface Props {}

const UnauthedHeader: React.FC<Props> = () => {
  const theme = useTheme();

  return (
    <Flex
      justifyContent="center"
      alignItems="center"
      width="100%"
      height={72}
      background={theme.palette.background.paper}
      flexShrink={0}
      borderBottom={`1px solid ${theme.palette.divider}`}
      boxShadow={`0px 1px 1px ${theme.palette.divider}`}
    >
      <NavLink to="/">
        <Div
          width={158}
          height={40}
          style={{
            // we can't use the background property of `Div` since it seems to use backgroundColor
            background: `no-repeat url(${
              theme.palette.mode === 'dark' ? secondaryLogo : primaryLogo
            })`,
          }}
        />
      </NavLink>
    </Flex>
  );
};

export default UnauthedHeader;
